import React from "react";
import aboutImg from "../../assets/img/Team.jpg";
import { Link } from "react-router-dom";
import "./OurApproach.css";

const OurApproach = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="row gy-4 align-items-center">
          {/* Left Content */}
          <div
            className="col-lg-6 order-2 order-lg-1 content"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <h3>Empowering Students with Practical Learning</h3>
            <p className="fst-italic">
              At Learnific Academy, we believe education goes beyond textbooks. Our
              mission is to create a learning experience that inspires
              curiosity, creativity, and confidence in every student.
            </p>
            <ul>
              <li>
                <i className="bi bi-check-circle"></i>
                Industry-relevant courses designed by experts to prepare you for
                real-world challenges.
              </li>
              <li>
                <i className="bi bi-check-circle"></i>
                Experienced mentors and educators providing personalized
                guidance.
              </li>
              <li>
                <i className="bi bi-check-circle"></i>
                Hands-on projects, internships, and skill-building workshops to
                boost your career opportunities.
              </li>
            </ul>
            <Link to="/about" className="read-more">
              <span>Learn More About Us</span>{" "}
              <i className="bi bi-arrow-right"></i>
            </Link>
          </div>

          {/* Right Image */}
          <div
            className="col-lg-6 order-1 order-lg-2 text-center"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <img src={aboutImg} className="img-fluid rounded" alt="Our Approach" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurApproach;
